import { Component, EventEmitter, Input, Output } from '@angular/core'
import {
  openCloseWidget,
  openCloseWidgetContent,
  openCloseWidgetHeader,
} from '../../utils/animations'

@Component({
  standalone: false,
  selector: 'app-widget-base',
  templateUrl: './widget-base.component.html',
  styleUrls: ['./widget-base.component.scss'],
  animations: [openCloseWidget, openCloseWidgetHeader, openCloseWidgetContent],
})
export class WidgetBaseComponent {
  @Input() title = ''
  @Input() highlight: any = []
  @Input() headerOverlay = false
  widgetCollapsed = false

  @Output() onCollapse = new EventEmitter()

  constructor() {}

  toggleWidget() {
    this.widgetCollapsed = !this.widgetCollapsed
    this.onCollapse.emit(this.widgetCollapsed)
  }
}
